import { render, staticRenderFns } from "./AdminPedidos.vue?vue&type=template&id=59156129&scoped=true"
import script from "./AdminPedidos.vue?vue&type=script&lang=js"
export * from "./AdminPedidos.vue?vue&type=script&lang=js"
import style0 from "@/assets/admin-styles.css?vue&type=style&index=0&id=59156129&prod&scoped=true&lang=css&external"
import style1 from "./AdminPedidos.vue?vue&type=style&index=1&id=59156129&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59156129",
  null
  
)

export default component.exports